import apiRequest from '@/http/api-request'
import authService from '@/auth/authService'
import {prepareDonationParams} from "@/utils/utils";
import { getDonationStats, getDonationsByDateRange, getDonationTimeSeries } from "@/utils/api";

const moment = require('moment');

export default {

  async fetchAllDonations(
    { commit, state }, 
    { charityId, force = false }) {

    if (state.donationsState === 'loading') {
      return new Promise((resolve) => resolve(state.donations));
    }

    if (state.donationsState === 'ready' && force !== true
      && (parseInt((new Date().getTime() / 1000)) - state.lastUpdate) < 60 * 15 //15 min cache
    ) {
      return new Promise((resolve) => resolve(state.donations));
    }

    commit('LOADING_DONATIONS');

    return new Promise((resolve, reject) => {
      return apiRequest.doGetRequest('/data/donations',
        {
          charity_id: charityId,
          start_date: '01/01/2016',
          end_date: moment().format('MM/DD/YYYY'),
        },
        {'X-Harness-JWT': authService.getToken()},
        {
          skipCache: true,
          resCallback: (donations) => {

            // Pre-parse the created_at timestamp so we don't need to re-parse it multiple times later.
            for (let donation of donations) {
              donation.createdAtParsed = moment(donation.created_at, 'YYYY/MM/DD HH:mm:ss').unix();
            }

            //This ensures backwards compatability as we will start returning pending transactions from the backend
            donations = donations.filter(donation=>{
              return (
                donation.status === undefined ||
                donation.status === "succeeded" ||
                (['succeeded', 'pending_verification', 'processing', 'failed'].includes(donation.status))
              );
            });

            return donations;
          },
        })
        .then(donations => {
          commit('SET_DONATIONS', donations);
          resolve(donations);
        })
        .catch((error) => reject(error));
    });
  },
  editDonationNode({state, commit}, {charityId, donationId, params}) {
    params = prepareDonationParams(params);

    return new Promise((resolve, reject) => {
      return apiRequest.doPatchRequest(
        `/charity/${charityId}/donation/${donationId}`, 
        params,
        {'content-type': 'application/json'},
      )
        .then(result => {

          if (params.hasOwnProperty('campaign_id')) {
            commit('EDIT_DONATION', {
              id: donationId,
              campaign_id: params.campaign_id,
            })
          }

          if (params.hasOwnProperty('note')) {
            if (typeof params.note === 'object' && params.note !== null) {
              commit('EDIT_DONATION', {
                id: donationId,
                note: params.note.message,
                is_note_public: params.note.public,
              })
            } else if (params.note === null) {
              commit('EDIT_DONATION', {
                id: donationId,
                note: null
              })
            }
          }

          if (params.hasOwnProperty('honor')) {
            const item = state.donations.find(item => item.id === donationId);

            const meta = JSON.parse(JSON.stringify(item.metadata));

            if (typeof params.honor === 'object' && params.honor !== null) {
              meta.honor = params.honor;
              commit('EDIT_DONATION', {
                id: donationId,
                metadata: meta,
              })
            } else if (params.note === null) {
              meta.honor = null;
              commit('EDIT_DONATION', {
                id: donationId,
                metadata: meta,
              })
            }
          }
          resolve(result)
        })
        .catch((error) => reject(error));
    })
  },
  refundDonation({commit}, {charityId, donationId, params}) {
    return new Promise((resolve, reject) => {
      return apiRequest.doPutRequest(
        `/charity/${charityId}/donation/${donationId}/refund`,
         params,
         {'content-type': 'application/json'},
        )
        .then(result => {
          commit('REMOVE_DONATION', donationId);
          resolve(result)
        })
        .catch((error) => reject(error));
    })
  },
  async fetchDonationStats({ commit }, charityId) {
    try {
      commit("SET_DONATION_STATS_STATE", "loading");
      const response = await getDonationStats(charityId);
      commit("SET_DONATION_STATS", response);
      commit("SET_DONATION_STATS_STATE", "ready");
    } catch (error) {
      commit("SET_DONATION_STATS_STATE", "error");
      throw error;
    }
  },

  async fetchDonationSummaryByDateRange({ commit }, { charityId, startDate, endDate }) {
    try {
      commit("SET_DONATION_SUMMARY_STATE", "loading");
      const response = await getDonationsByDateRange(charityId, startDate, endDate);
      commit("SET_DONATION_SUMMARY", response);
      commit("SET_DONATION_SUMMARY_STATE", "ready");
    } catch (error) {
      commit("SET_DONATION_SUMMARY_STATE", "error");
      throw error;
    }
  },

  async fetchDonationTimeSeries({ commit }, { charityId, startDate, endDate }) {
    try {
      commit("SET_DONATION_TIME_SERIES_STATE", "loading");
      const response = await getDonationTimeSeries(charityId, startDate, endDate);
      commit("SET_DONATION_TIME_SERIES", response);
      commit("SET_DONATION_TIME_SERIES_STATE", "ready");
    } catch (error) {
      commit("SET_DONATION_TIME_SERIES_STATE", "error");
      throw error;
    }
  }

}
